import * as Immutable from "immutable";
import { validateResponseMessageURL } from "services/strings";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class WebWindowMessageRecord
 * @augments BaseMessageRecord
 */
class WebWindowMessageRecord extends BaseMessageRecord({
  type: "web_window",

  /**
   * @memberof WebWindowMessageRecord#
   */
  isHandoff: false,
  windowButtonLabel: "",
  windowHeight: "",
  windowTitle: "",
  windowUrl: "",
  windowWidth: ""
}) {}

/**
 * @param {WebWindowMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
WebWindowMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!validateResponseMessageURL(message.windowUrl)) {
    invalidFields.add("windowUrl");
  }

  if (message.windowTitle.length <= 0) {
    invalidFields.add("windowTitle");
  }

  if (message.windowButtonLabel.length <= 0) {
    invalidFields.add("windowButtonLabel");
  }

  if (message.windowWidth.length <= 0) {
    invalidFields.add("windowWidth");
  }

  if (message.windowHeight.length <= 0) {
    invalidFields.add("windowHeight");
  }

  return Immutable.List(invalidFields);
};

export default WebWindowMessageRecord;
